/**
 * @file: getFuelTypeByRawValue.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { VehicleFuelType } from '@euler/model/enum';
import { isValidLicensePlateNo } from '@euler/utils/validators';

export const getFuelTypeByRawValue = (
  licensePlateNo: string,
  fuelTypeString: string | null | undefined,
): VehicleFuelType | undefined => {
  fuelTypeString = fuelTypeString?.trim().toUpperCase();
  if (fuelTypeString == null) {
    return getFuelTypeByLicensePlateNo(licensePlateNo);
  }
  if (fuelTypeString.includes('柴油')) {
    return VehicleFuelType.Diesel;
  }
  if (fuelTypeString.includes('汽油')) {
    return VehicleFuelType.Gasoline;
  }
  if (fuelTypeString.includes('NG') || fuelTypeString.includes('天然气')) {
    return VehicleFuelType.Natgas;
  }
  if (fuelTypeString.includes('甲醇')) {
    return VehicleFuelType.Methanol;
  }
  if (
    fuelTypeString.includes('氢燃料') ||
    fuelTypeString.includes('燃料电池')
  ) {
    return VehicleFuelType.FuelCell;
  }
  if (fuelTypeString.includes('纯电') || fuelTypeString === '电动') {
    return VehicleFuelType.Electric;
  }
  if (fuelTypeString.includes('插电')) {
    return VehicleFuelType.PluginHybridElectric;
  }
  return VehicleFuelType.HybridElectric;
};

export const getFuelTypeByLicensePlateNo = (
  s: string,
): VehicleFuelType | undefined => {
  if (!isValidLicensePlateNo(s)) {
    return undefined;
  }
  s = s.slice(2);
  if (s.length < 6) {
    return VehicleFuelType.Gasoline;
  }
  const [first, last] = [s, s.slice(-1)];
  if (first === 'D' || last === 'D') {
    return VehicleFuelType.Electric;
  }
  return VehicleFuelType.HybridElectric;
};
